"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgLargePrevious = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 68 68", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M34 8.4C19.9 8.4 8.4 19.9 8.4 34c0 14.1 11.5 25.6 25.6 25.6 14.1 0 25.6-11.5 25.6-25.6C59.6 19.9 48.1 8.4 34 8.4zm12.8 27.7H26.4l4.9 4.9c.8.8.8 2.2 0 3-.4.4-1 .6-1.5.6s-1.1-.2-1.5-.6l-8.5-8.5c-.8-.8-.8-2.2 0-3l8.5-8.5c.8-.8 2.2-.8 3 0 .8.8.8 2.2 0 3l-4.9 4.9h20.4c1.2 0 2.1 1 2.1 2.1s-1 2.1-2.1 2.1z" })));
};
exports.default = SvgLargePrevious;
//# sourceMappingURL=LargePrevious.js.map